module.exports = __webpack_public_path__ + "static/media/adaptacion del arco - adaptado 100.ab6eba31.png";